const QuestionAnswer = () => import(/* webpackChunkName: "questionAnswer" */ '../views/Qna/QnaHome.vue')
const TanyaSaham = () =>
  import(/* webpackChunkName: "tanyaSaham" */ '../views/Qna/StockQuestion.vue')
const TanyaCustom = () =>
  import(/* webpackChunkName: "tanyaCusom" */ '../views/Qna/GeneralQuestion.vue')
const TanyaPortofolio = () =>
  import(/* webpackChunkName: "tanyaPorto" */ '../views/Qna/PortfolioQuestion.vue')
const QuestionHistory = () =>
  import(/* webpackChunkName: "questionHistory" */ '../views/Qna/HistoryQuestion.vue')
const QuestionHistoryDetail = () =>
  import(/* webpackChunkName: "questionHistoryDetail" */ '../views/Qna/HistoryDetailQuestion.vue')
const Faq = () => import(/* webpackChunkName: "faq" */ '../views/Qna/Faq.vue')
const FaqDetail = () =>
  import(/* webpackChunkName: "faqDetail" */ '../views/Qna/FaqDetail.vue')

const QnaRoute = [
  {
    path: '/qna',
    name: 'qna',
    component: QuestionAnswer,
    meta: {
      requiresAuth: true,
      hiddeMenu: false,
      navBar: true,
      navBarBack: false,
      title: 'Q&A',
      backLink: 'dashboard',
    },
  },
  {
    path: '/qna/tanya-saham/detail',
    name: 'tanyasaham',
    component: TanyaSaham,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'Tanya Saham',
      backLink: 'qna',
    },
  },
  {
    path: '/qna/tanya-custom/detail',
    name: 'tanyacustom',
    component: TanyaCustom,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'Tanya',
      backLink: 'qna',
    },
  },
  {
    path: '/qna/tanya-portofolio/detail',
    name: 'tanyaportofolio',
    component: TanyaPortofolio,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'Tanya Portofolio',
      backLink: 'qna',
    },
  },
  {
    path: '/qna/history',
    name: 'qnahistory',
    component: QuestionHistory,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'History',
      backLink: 'qna',
    },
  },
  {
    path: '/qna/history/:parent_id',
    name: 'qnahistorydetail',
    component: QuestionHistoryDetail,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'History Detail',
      backLink: 'qnahistory',
    },
  },
  {
    path: '/qna/faq/:slug',
    name: 'qnafaq',
    component: Faq,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: '',
      backLink: 'qna',
    },
  },
  {
    path: '/qna/faq/:slug/detail/:id',
    name: 'qnafaqdetail',
    component: FaqDetail,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: '',
      backLink: 'qnafaq',
    },
  },
  {
    path: '/qna/faq/home/detail/:id',
    name: 'qnafaqhomedetail',
    component: FaqDetail,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'Q&A',
      backLink: 'dashboard',
    },
  },
]

export default QnaRoute
